import { render, staticRenderFns } from "./IconPinDrop.vue?vue&type=template&id=36f01b1b&"
import script from "./IconPinDrop.vue?vue&type=script&lang=ts&"
export * from "./IconPinDrop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports